import { render, staticRenderFns } from "./SetMaterialEditor.vue?vue&type=template&id=5ded2b8c&scoped=true&"
import script from "./SetMaterialEditor.vue?vue&type=script&lang=js&"
export * from "./SetMaterialEditor.vue?vue&type=script&lang=js&"
import style0 from "./SetMaterialEditor.vue?vue&type=style&index=0&id=5ded2b8c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ded2b8c",
  null
  
)

export default component.exports